import { render, staticRenderFns } from "./ReportsPageHeader.component.vue?vue&type=template&id=8304dd0e&scoped=true&"
import script from "./ReportsPageHeader.component.vue?vue&type=script&lang=ts&"
export * from "./ReportsPageHeader.component.vue?vue&type=script&lang=ts&"
import style0 from "./ReportsPageHeader.component.vue?vue&type=style&index=0&id=8304dd0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8304dd0e",
  null
  
)

export default component.exports